import { State } from 'app/redux';

export const getCarriers = (state: State) => state.carrier.carriers;

export const getSearches = (state: State) => state.carrier.searches;
